export default "__VITE_ASSET__AZnwcqbS__"